import Immutable from 'seamless-immutable';

import { appConfig } from 'config/customization';
import { message } from 'utils/stringUtils';
import numeral from 'config/numeral';
/**
 * Receives an array of strings, and returns an obj with that strings as properties with that string as value.
 * E.G:
 * stringArrayToObject(['A', 'B', 'C']) // { A: 'A', B: 'B', C: 'C' }
 */
export function stringArrayToObject(actionsArray, namespace = '') {
  if (actionsArray.some(actionName => !actionName || typeof actionName !== 'string')) {
    throw new Error('Action names must be strings and must not be empty');
  }
  const actions = Immutable(actionsArray);
  return Immutable.asObject(actions, actionName => [actionName, `${namespace}:${actionName}`]);
}

export const findMessages = values =>
  values
    .filter(element => element.message)
    .map(element => ({ client_number: element.client_number, message: element.message }));

export const mapPaymentFlowError = (totalAmount, paymentDetails, apiMaxAmount, apiMaxDocs) => {
  let error;
  if (totalAmount === 0 || !totalAmount) {
    error = message('Payments:payZeroError');
  }

  if (totalAmount > (apiMaxAmount || appConfig.maxAmountThreshold)) {
    error = message('Payments:maxAmountThreshold', {
      amount: numeral(appConfig.maxAmountThreshold).format('$0,0.[00]')
    });
  }

  if (paymentDetails && paymentDetails.length > (apiMaxDocs || appConfig.maxDocsThreshold)) {
    error = message('Payments:maxDocsThreshold', { docs: appConfig.maxDocsThreshold });
  }

  return error;
};

export const retrieveSignUpNextSteps = currentStep => {
  let nextStepOnSuccess;
  switch (currentStep) {
    case 1: {
      nextStepOnSuccess = appConfig.signUpFlow.IdentityValidation ? 2 : 3;
      break;
    }
    case 2: {
      nextStepOnSuccess = 3;
      break;
    }
    case 3: {
      nextStepOnSuccess = appConfig.signUpFlow.TermsAndConditions ? 4 : 5;
      break;
    }
    case 4: {
      nextStepOnSuccess = 5;
      break;
    }
    case 5: {
      nextStepOnSuccess = appConfig.signUpFlow.AddAccount ? 6 : 0;
      break;
    }
    case 6: {
      nextStepOnSuccess = appConfig.signUpFlow.AccountRelationshipValidation
        ? 7
        : appConfig.signUpFlow.ServiceAdherence
        ? 8
        : appConfig.signUpFlow.RelatedAccounts
        ? 9
        : 0;
      break;
    }
    case 7: {
      nextStepOnSuccess = appConfig.signUpFlow.ServiceAdherence
        ? 8
        : appConfig.signUpFlow.RelatedAccounts
        ? 9
        : 0;
      break;
    }
    case 8: {
      nextStepOnSuccess = appConfig.signUpFlow.RelatedAccounts ? 9 : 0;
      break;
    }
    case 9: {
      nextStepOnSuccess = appConfig.signUpFlow.ServiceAdherence ? 10 : 0;
      break;
    }
    case 10: {
      nextStepOnSuccess = 0;
      break;
    }
    default: {
      nextStepOnSuccess = appConfig.signUpFlow.IdentityValidation ? 2 : 3;
    }
  }
  return nextStepOnSuccess;
};
